import { render } from "./Rights.vue?vue&type=template&id=40b727d8"
import script from "./Rights.vue?vue&type=script&lang=js"
export * from "./Rights.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__